import axiosDBClient from 'axiosDBClient';
import { areas, INSIGHT_TYPE_CODE } from 'constants/constants';
import { setAllDView, setAllMView } from 'store/home/homeMyViewSlice';
import { trackPromise } from 'react-promise-tracker';

export const getUserViewsData = (roleId, unixId, type) => {
  return async (dispatch) => {
    try {
      const getUserViews = async (roleId, unixId, type) => {
        return await axiosDBClient.get(
          `v2/view-list/user-views?unixId=${unixId}&roleId=${roleId}&type=${type}`
        );
      };
      trackPromise(
        getUserViews(roleId, unixId, type).then((response) => {
          if (type === INSIGHT_TYPE_CODE.SAMPLE)
            dispatch(setAllDView(response?.data?.result ?? []));
          else dispatch(setAllMView(response?.data?.result ?? []));
        }),
        areas.userView
      );
    } catch (error) {
      console.log(error);
    }
  };
};

export const addNewUserView = async (payload) => {
  const response = await axiosDBClient.post('v2/view-list/user-views', {
    ...payload,
  });

  if (response.data.error) {
    throw new Error('Could not add data!');
  }

  return response.data;
};
export const copyViewToMyView = async (payload) => {
  const response = await axiosDBClient.post('v2/view-list/user-views/copy', {
    ...payload,
  });

  if (response.data.error) {
    throw new Error('Could not copy data!');
  }

  return response.data;
};

export const renameUserView = async (payload) => {
  const response = await axiosDBClient.patch(
    `v2/view-list/user-views/${payload.id}`,
    {
      ...payload,
    }
  );

  if (response.data.error) {
    throw new Error('Could not rename data!');
  }

  return response.data;
};

export const deleteUserView = async (id) => {
  try {
    const response = await trackPromise(
      axiosDBClient.delete(`v2/view-list/user-views/${id}`),
      areas.deleteCardsThenView
    );
    return response.status === 200;
  } catch (error) {
    console.log(error);
    return false;
  }
};
